<template>
  <section :class="['profile__block', { 'pattern' : fit, 'height_to_fit' : fit }]">
    <div class="profile__block__header">
      <h2>{{ title }}</h2>
    </div>
    <stat-performance :user-info="userInfo"/>
    <div class="profile__block__header subheader" v-if="themes.length">
      <h2>{{ subTitle }}</h2>
    </div>
    <theme-performance :theme-stats="themes"/>
    <slot></slot>
  </section>
</template>

<script>
import ThemePerformance from '@/components/home/profile/ThemePerformance';
import StatPerformance from '@/components/home/profile/StatPerformance';

export default {
  name: 'performance',
  props: {
    title: String,
    subTitle: String,
    fit: Boolean,
    userInfo: {
      type: Object,
      required: true,
    },
    themes: {
      type: Array,
      required: true,
    },
  },
  components: {
    ThemePerformance,
    StatPerformance,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/Performance.vue